import {
  InflammagingTrend,
  Trend,
  RichnessTrend,
} from '@viome/viome-base/src/usecase/Health/Health.model';
import { VGraphData } from '@/components/shared/VGraph';

export const transformInflammagingToVGraph = (
  data: InflammagingTrend[],
): VGraphData[] =>
  data.map((item) => ({
    color: item.rank_color,
    date: item.date,
    message: item.message,
    score: getScore(item.message),
    sequence_no: item.sequence_number,
  }));

export const transformTrendToVGraph = (data: Trend[]): VGraphData[] =>
  data.map((item) => ({
    color: item.color,
    date: item.date,
    score: item.score,
    sequence_no: item.sequence_no,
    message: `${item.score}`,
  }));

export const transformRichnessToVGraph = (
  data: RichnessTrend[],
): VGraphData[] =>
  data.map((item) => ({
    color: getScoreColor(item.message),
    date: item.date,
    score: item.percentage,
    sequence_no: item.sequence_number,
    message: `${item.percentage}`,
  }));

export const getScore = (message: string): number => {
  switch (message.toLowerCase()) {
    case 'high':
      return 100;
    case 'medium':
      return 50;
    case 'low':
      return 0;
    default:
      return 0;
  }
};

const getScoreColor = (message: string): string => {
  switch (message.toLowerCase()) {
    case 'high':
      return '#00CA9F';
    case 'medium':
      return '#FFAB01';
    case 'low':
      return '#FF3A3A';
    default:
      return '#00CA9F';
  }
};
